export function authHeader() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.auth_token) {
        return { 'Authorization': user.auth_token };
    } else {
        return {};
    }
}